/**
 * © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED
 * Tinder Obsidian v10.18.0
 * Do not edit directly
 * Generated on Fri, 01 Nov 2024 18:19:22 GMT
 */

import { ObsidianBaseTheme } from '../types';
import {
  COLOR_BLACK,
  COLOR_BLUE_05,
  COLOR_BLUE_10,
  COLOR_BLUE_15,
  COLOR_BLUE_20,
  COLOR_BLUE_30,
  COLOR_BLUE_40,
  COLOR_BLUE_50,
  COLOR_BLUE_60,
  COLOR_BLUE_70,
  COLOR_BLUE_80,
  COLOR_BLUE_90,
  COLOR_BLUE_95,
  COLOR_BRAND_GRADIENT_END,
  COLOR_BRAND_GRADIENT_START,
  COLOR_BRAND_PRIMARY,
  COLOR_BRAND_PRIMARY_A11Y,
  COLOR_FUCHSIA_05,
  COLOR_FUCHSIA_10,
  COLOR_FUCHSIA_15,
  COLOR_FUCHSIA_20,
  COLOR_FUCHSIA_30,
  COLOR_FUCHSIA_40,
  COLOR_FUCHSIA_50,
  COLOR_FUCHSIA_60,
  COLOR_FUCHSIA_70,
  COLOR_FUCHSIA_80,
  COLOR_FUCHSIA_90,
  COLOR_FUCHSIA_95,
  COLOR_GOLD_05,
  COLOR_GOLD_10,
  COLOR_GOLD_15,
  COLOR_GOLD_20,
  COLOR_GOLD_30,
  COLOR_GOLD_40,
  COLOR_GOLD_50,
  COLOR_GOLD_60,
  COLOR_GOLD_70,
  COLOR_GOLD_80,
  COLOR_GOLD_90,
  COLOR_GOLD_95,
  COLOR_GRAY_05,
  COLOR_GRAY_10,
  COLOR_GRAY_15,
  COLOR_GRAY_20,
  COLOR_GRAY_30,
  COLOR_GRAY_40,
  COLOR_GRAY_50,
  COLOR_GRAY_60,
  COLOR_GRAY_70,
  COLOR_GRAY_80,
  COLOR_GRAY_90,
  COLOR_GRAY_95,
  COLOR_GREEN_05,
  COLOR_GREEN_10,
  COLOR_GREEN_15,
  COLOR_GREEN_20,
  COLOR_GREEN_30,
  COLOR_GREEN_40,
  COLOR_GREEN_50,
  COLOR_GREEN_60,
  COLOR_GREEN_70,
  COLOR_GREEN_80,
  COLOR_GREEN_90,
  COLOR_GREEN_95,
  COLOR_MATCH_EXPIRATION_PRIMARY,
  COLOR_MATCH_EXPIRATION_PRIMARY_ON_DARK,
  COLOR_MATCH_EXPIRATION_SECONDARY,
  COLOR_OPACITY_BLACK_05,
  COLOR_OPACITY_BLACK_10,
  COLOR_OPACITY_BLACK_15,
  COLOR_OPACITY_BLACK_20,
  COLOR_OPACITY_BLACK_30,
  COLOR_OPACITY_BLACK_40,
  COLOR_OPACITY_BLACK_50,
  COLOR_OPACITY_BLACK_60,
  COLOR_OPACITY_BLACK_70,
  COLOR_OPACITY_BLACK_80,
  COLOR_OPACITY_BLACK_90,
  COLOR_OPACITY_BLACK_95,
  COLOR_OPACITY_WHITE_05,
  COLOR_OPACITY_WHITE_10,
  COLOR_OPACITY_WHITE_15,
  COLOR_OPACITY_WHITE_20,
  COLOR_OPACITY_WHITE_30,
  COLOR_OPACITY_WHITE_40,
  COLOR_OPACITY_WHITE_50,
  COLOR_OPACITY_WHITE_60,
  COLOR_OPACITY_WHITE_70,
  COLOR_OPACITY_WHITE_80,
  COLOR_OPACITY_WHITE_90,
  COLOR_OPACITY_WHITE_95,
  COLOR_PURPLE_05,
  COLOR_PURPLE_10,
  COLOR_PURPLE_15,
  COLOR_PURPLE_20,
  COLOR_PURPLE_30,
  COLOR_PURPLE_40,
  COLOR_PURPLE_50,
  COLOR_PURPLE_60,
  COLOR_PURPLE_70,
  COLOR_PURPLE_80,
  COLOR_PURPLE_90,
  COLOR_PURPLE_95,
  COLOR_RED_05,
  COLOR_RED_10,
  COLOR_RED_15,
  COLOR_RED_20,
  COLOR_RED_30,
  COLOR_RED_40,
  COLOR_RED_50,
  COLOR_RED_60,
  COLOR_RED_70,
  COLOR_RED_80,
  COLOR_RED_90,
  COLOR_RED_95,
  COLOR_SPARKS_BLUE_50,
  COLOR_SPARKS_BLUE_70,
  COLOR_SPARKS_GRAY_BLUE_15,
  COLOR_SPARKS_GRAY_BLUE_30,
  COLOR_SPARKS_GRAY_BLUE_80,
  COLOR_SPARKS_GRAY_BLUE_90,
  COLOR_SPARKS_GREEN_20,
  COLOR_SPARKS_GREEN_30,
  COLOR_SPARKS_GREEN_40,
  COLOR_SPARKS_ORANGE_50,
  COLOR_SPARKS_PINK_45,
  COLOR_SPARKS_PURPLE_60,
  COLOR_SPARKS_RED_60,
  COLOR_SPARKS_TEAL_20,
  COLOR_SPARKS_YELLOW_20,
  COLOR_SPARKS_YELLOW_30,
  COLOR_TEAL_05,
  COLOR_TEAL_10,
  COLOR_TEAL_15,
  COLOR_TEAL_20,
  COLOR_TEAL_30,
  COLOR_TEAL_40,
  COLOR_TEAL_50,
  COLOR_TEAL_60,
  COLOR_TEAL_70,
  COLOR_TEAL_80,
  COLOR_TEAL_90,
  COLOR_TEAL_95,
  COLOR_THIRD_PARTY_FACEBOOK_PRIMARY,
  COLOR_THIRD_PARTY_LINE_A11Y,
  COLOR_THIRD_PARTY_LINE_PRIMARY,
  COLOR_THIRD_PARTY_NOONLIGHT_PRIMARY,
  COLOR_THIRD_PARTY_NOONLIGHT_SECONDARY,
  COLOR_THIRD_PARTY_SPOTIFY_PRIMARY,
  COLOR_THIRD_PARTY_SPOTIFY_PRIMARY_INVERSE,
  COLOR_TRANSPARENT,
  COLOR_VAULT_INDIGO_20,
  COLOR_VAULT_INDIGO_95,
  COLOR_VAULT_PRIMARY,
  COLOR_VAULT_PRIMARY_LIGHT,
  COLOR_WHITE,
  COLOR_YELLOW_ORANGE_05,
  COLOR_YELLOW_ORANGE_10,
  COLOR_YELLOW_ORANGE_15,
  COLOR_YELLOW_ORANGE_20,
  COLOR_YELLOW_ORANGE_30,
  COLOR_YELLOW_ORANGE_40,
  COLOR_YELLOW_ORANGE_50,
  COLOR_YELLOW_ORANGE_60,
  COLOR_YELLOW_ORANGE_70,
  COLOR_YELLOW_ORANGE_80,
  COLOR_YELLOW_ORANGE_90,
  COLOR_YELLOW_ORANGE_95,
  FONT_SIZE_BASE,
  GRADIENT_BRAND_GRADIENT,
  GRADIENT_BRAND_SUBTLE,
  GRADIENT_BRAND_SUBTLE_ON_DARK,
  GRADIENT_EXPLORE_ATTRIBUTION_GRADIENT,
  GRADIENT_FESTIVAL_MODE_GRADIENT,
  GRADIENT_GAMEPAD_BOOST,
  GRADIENT_GAMEPAD_BOOST_ON_DARK,
  GRADIENT_GAMEPAD_BOOST_SUBTLE,
  GRADIENT_GAMEPAD_BOOST_SUBTLE_ON_DARK,
  GRADIENT_GAMEPAD_LIKE,
  GRADIENT_GAMEPAD_LIKE_ON_DARK,
  GRADIENT_GAMEPAD_LIKE_ON_LIGHT,
  GRADIENT_GAMEPAD_LIKE_SUBTLE,
  GRADIENT_GAMEPAD_LIKE_SUBTLE_ON_DARK,
  GRADIENT_GAMEPAD_NOPE_ON_DARK,
  GRADIENT_GAMEPAD_REWIND,
  GRADIENT_GAMEPAD_REWIND_ON_DARK,
  GRADIENT_GAMEPAD_SPARKS_BOOST,
  GRADIENT_GAMEPAD_SPARKS_LIKE,
  GRADIENT_GAMEPAD_SPARKS_NOPE,
  GRADIENT_GAMEPAD_SPARKS_REWIND,
  GRADIENT_GAMEPAD_SPARKS_SUPER_LIKE,
  GRADIENT_GAMEPAD_SUPER_BOOST,
  GRADIENT_GAMEPAD_SUPER_BOOST_ON_DARK,
  GRADIENT_GAMEPAD_SUPER_BOOST_SUBTLE,
  GRADIENT_GAMEPAD_SUPER_BOOST_SUBTLE_ON_DARK,
  GRADIENT_GAMEPAD_SUPER_LIKE,
  GRADIENT_GAMEPAD_SUPER_LIKE_ON_DARK,
  GRADIENT_GAMEPAD_SUPER_LIKE_ON_LIGHT,
  GRADIENT_GAMEPAD_SUPER_LIKE_SUBTLE,
  GRADIENT_GAMEPAD_SUPER_LIKE_SUBTLE_ON_DARK,
  GRADIENT_HOT_TAKES_GRADIENT,
  GRADIENT_MATCH_EXPIRATION_GRADIENT,
  GRADIENT_MATCH_EXPIRATION_GRADIENT_ON_DARK,
  GRADIENT_PASSIONS_GRADIENT,
  GRADIENT_REVENUE_GOLD,
  GRADIENT_REVENUE_GOLD_ON_DARK,
  GRADIENT_REVENUE_GOLD_SHINE,
  GRADIENT_REVENUE_GOLD_SHINE_ANIMATION,
  GRADIENT_REVENUE_GOLD_SHINE_ANIMATION_ON_DARK,
  GRADIENT_REVENUE_GOLD_SHINE_ON_DARK,
  GRADIENT_REVENUE_GOLD_SUBTLE,
  GRADIENT_REVENUE_GOLD_SUBTLE_ON_DARK,
  GRADIENT_REVENUE_PLATINUM,
  GRADIENT_REVENUE_PLATINUM_ON_DARK,
  GRADIENT_REVENUE_PLATINUM_SHINE,
  GRADIENT_REVENUE_PLATINUM_SHINE_ANIMATION,
  GRADIENT_REVENUE_PLATINUM_SHINE_ANIMATION_ON_DARK,
  GRADIENT_REVENUE_PLATINUM_SHINE_ON_DARK,
  GRADIENT_REVENUE_PLATINUM_SUBTLE,
  GRADIENT_REVENUE_PLATINUM_SUBTLE_ON_DARK,
  GRADIENT_REVENUE_PLUS,
  GRADIENT_REVENUE_PLUS_ON_DARK,
  GRADIENT_REVENUE_PLUS_SUBTLE,
  GRADIENT_REVENUE_PLUS_SUBTLE_ON_DARK,
  GRADIENT_SPARKS_BACKGROUND_GRADIENT,
  GRADIENT_SPARKS_BACKGROUND_GRADIENT_DARK,
  GRADIENT_SPARKS_MATCHMAKER_ATTRIBUTION,
  GRADIENT_SPOTIFY_MUSIC_MODE_GRADIENT,
  GRADIENT_VAULT_GRADIENT,
  GRADIENT_VAULT_SUBTLE_ON_DARK,
  GRADIENT_VAULT_SUBTLE_ON_LIGHT,
  GRADIENT_VIBES_GRADIENT,
  LETTER_CASING_NONE,
  SIZING_0,
  SIZING_10,
  SIZING_100,
  SIZING_110,
  SIZING_120,
  SIZING_125,
  SIZING_130,
  SIZING_140,
  SIZING_15,
  SIZING_150,
  SIZING_160,
  SIZING_170,
  SIZING_180,
  SIZING_190,
  SIZING_20,
  SIZING_200,
  SIZING_210,
  SIZING_220,
  SIZING_230,
  SIZING_240,
  SIZING_30,
  SIZING_40,
  SIZING_5,
  SIZING_50,
  SIZING_60,
  SIZING_70,
  SIZING_80,
  SIZING_90,
  TYPE_STYLE_BODY_1_LINK,
  TYPE_STYLE_BODY_1_REGULAR,
  TYPE_STYLE_BODY_1_SPARKS_SEMIBOLD,
  TYPE_STYLE_BODY_1_STRONG,
  TYPE_STYLE_BODY_2_LINK,
  TYPE_STYLE_BODY_2_REGULAR,
  TYPE_STYLE_BODY_2_SPARKS_SEMIBOLD,
  TYPE_STYLE_BODY_2_STRONG,
  TYPE_STYLE_BODY_3_LINK,
  TYPE_STYLE_BODY_3_REGULAR,
  TYPE_STYLE_BODY_3_STRONG,
  TYPE_STYLE_BUTTON_1,
  TYPE_STYLE_BUTTON_2,
  TYPE_STYLE_CAPTION_1_LINK,
  TYPE_STYLE_CAPTION_1_REGULAR,
  TYPE_STYLE_CAPTION_1_STRONG,
  TYPE_STYLE_DISPLAY_1_REGULAR,
  TYPE_STYLE_DISPLAY_1_STRONG,
  TYPE_STYLE_DISPLAY_2_REGULAR,
  TYPE_STYLE_DISPLAY_2_SPARKS_REGULAR,
  TYPE_STYLE_DISPLAY_2_SPARKS_STRONG,
  TYPE_STYLE_DISPLAY_2_STRONG,
  TYPE_STYLE_DISPLAY_3_REGULAR,
  TYPE_STYLE_DISPLAY_3_STRONG,
  TYPE_STYLE_HEADING_1,
  TYPE_STYLE_SUBHEADING_1,
  TYPE_STYLE_SUBHEADING_2,
} from '../constants';

export default {
  version: '10.18.0',
  themeId: 'base',
  name: 'Base Tokens',
  dark: false,
  color: {
    black: COLOR_BLACK,
    blue05: COLOR_BLUE_05,
    blue10: COLOR_BLUE_10,
    blue15: COLOR_BLUE_15,
    blue20: COLOR_BLUE_20,
    blue30: COLOR_BLUE_30,
    blue40: COLOR_BLUE_40,
    blue50: COLOR_BLUE_50,
    blue60: COLOR_BLUE_60,
    blue70: COLOR_BLUE_70,
    blue80: COLOR_BLUE_80,
    blue90: COLOR_BLUE_90,
    blue95: COLOR_BLUE_95,
    brandGradientEnd: COLOR_BRAND_GRADIENT_END,
    brandGradientStart: COLOR_BRAND_GRADIENT_START,
    brandPrimary: COLOR_BRAND_PRIMARY,
    brandPrimaryA11y: COLOR_BRAND_PRIMARY_A11Y,
    fuchsia05: COLOR_FUCHSIA_05,
    fuchsia10: COLOR_FUCHSIA_10,
    fuchsia15: COLOR_FUCHSIA_15,
    fuchsia20: COLOR_FUCHSIA_20,
    fuchsia30: COLOR_FUCHSIA_30,
    fuchsia40: COLOR_FUCHSIA_40,
    fuchsia50: COLOR_FUCHSIA_50,
    fuchsia60: COLOR_FUCHSIA_60,
    fuchsia70: COLOR_FUCHSIA_70,
    fuchsia80: COLOR_FUCHSIA_80,
    fuchsia90: COLOR_FUCHSIA_90,
    fuchsia95: COLOR_FUCHSIA_95,
    gold05: COLOR_GOLD_05,
    gold10: COLOR_GOLD_10,
    gold15: COLOR_GOLD_15,
    gold20: COLOR_GOLD_20,
    gold30: COLOR_GOLD_30,
    gold40: COLOR_GOLD_40,
    gold50: COLOR_GOLD_50,
    gold60: COLOR_GOLD_60,
    gold70: COLOR_GOLD_70,
    gold80: COLOR_GOLD_80,
    gold90: COLOR_GOLD_90,
    gold95: COLOR_GOLD_95,
    gray05: COLOR_GRAY_05,
    gray10: COLOR_GRAY_10,
    gray15: COLOR_GRAY_15,
    gray20: COLOR_GRAY_20,
    gray30: COLOR_GRAY_30,
    gray40: COLOR_GRAY_40,
    gray50: COLOR_GRAY_50,
    gray60: COLOR_GRAY_60,
    gray70: COLOR_GRAY_70,
    gray80: COLOR_GRAY_80,
    gray90: COLOR_GRAY_90,
    gray95: COLOR_GRAY_95,
    green05: COLOR_GREEN_05,
    green10: COLOR_GREEN_10,
    green15: COLOR_GREEN_15,
    green20: COLOR_GREEN_20,
    green30: COLOR_GREEN_30,
    green40: COLOR_GREEN_40,
    green50: COLOR_GREEN_50,
    green60: COLOR_GREEN_60,
    green70: COLOR_GREEN_70,
    green80: COLOR_GREEN_80,
    green90: COLOR_GREEN_90,
    green95: COLOR_GREEN_95,
    matchExpirationPrimary: COLOR_MATCH_EXPIRATION_PRIMARY,
    matchExpirationPrimaryOnDark: COLOR_MATCH_EXPIRATION_PRIMARY_ON_DARK,
    matchExpirationSecondary: COLOR_MATCH_EXPIRATION_SECONDARY,
    opacityBlack05: COLOR_OPACITY_BLACK_05,
    opacityBlack10: COLOR_OPACITY_BLACK_10,
    opacityBlack15: COLOR_OPACITY_BLACK_15,
    opacityBlack20: COLOR_OPACITY_BLACK_20,
    opacityBlack30: COLOR_OPACITY_BLACK_30,
    opacityBlack40: COLOR_OPACITY_BLACK_40,
    opacityBlack50: COLOR_OPACITY_BLACK_50,
    opacityBlack60: COLOR_OPACITY_BLACK_60,
    opacityBlack70: COLOR_OPACITY_BLACK_70,
    opacityBlack80: COLOR_OPACITY_BLACK_80,
    opacityBlack90: COLOR_OPACITY_BLACK_90,
    opacityBlack95: COLOR_OPACITY_BLACK_95,
    opacityWhite05: COLOR_OPACITY_WHITE_05,
    opacityWhite10: COLOR_OPACITY_WHITE_10,
    opacityWhite15: COLOR_OPACITY_WHITE_15,
    opacityWhite20: COLOR_OPACITY_WHITE_20,
    opacityWhite30: COLOR_OPACITY_WHITE_30,
    opacityWhite40: COLOR_OPACITY_WHITE_40,
    opacityWhite50: COLOR_OPACITY_WHITE_50,
    opacityWhite60: COLOR_OPACITY_WHITE_60,
    opacityWhite70: COLOR_OPACITY_WHITE_70,
    opacityWhite80: COLOR_OPACITY_WHITE_80,
    opacityWhite90: COLOR_OPACITY_WHITE_90,
    opacityWhite95: COLOR_OPACITY_WHITE_95,
    purple05: COLOR_PURPLE_05,
    purple10: COLOR_PURPLE_10,
    purple15: COLOR_PURPLE_15,
    purple20: COLOR_PURPLE_20,
    purple30: COLOR_PURPLE_30,
    purple40: COLOR_PURPLE_40,
    purple50: COLOR_PURPLE_50,
    purple60: COLOR_PURPLE_60,
    purple70: COLOR_PURPLE_70,
    purple80: COLOR_PURPLE_80,
    purple90: COLOR_PURPLE_90,
    purple95: COLOR_PURPLE_95,
    red05: COLOR_RED_05,
    red10: COLOR_RED_10,
    red15: COLOR_RED_15,
    red20: COLOR_RED_20,
    red30: COLOR_RED_30,
    red40: COLOR_RED_40,
    red50: COLOR_RED_50,
    red60: COLOR_RED_60,
    red70: COLOR_RED_70,
    red80: COLOR_RED_80,
    red90: COLOR_RED_90,
    red95: COLOR_RED_95,
    sparksBlue50: COLOR_SPARKS_BLUE_50,
    sparksBlue70: COLOR_SPARKS_BLUE_70,
    sparksGrayBlue15: COLOR_SPARKS_GRAY_BLUE_15,
    sparksGrayBlue30: COLOR_SPARKS_GRAY_BLUE_30,
    sparksGrayBlue80: COLOR_SPARKS_GRAY_BLUE_80,
    sparksGrayBlue90: COLOR_SPARKS_GRAY_BLUE_90,
    sparksGreen20: COLOR_SPARKS_GREEN_20,
    sparksGreen30: COLOR_SPARKS_GREEN_30,
    sparksGreen40: COLOR_SPARKS_GREEN_40,
    sparksOrange50: COLOR_SPARKS_ORANGE_50,
    sparksPink45: COLOR_SPARKS_PINK_45,
    sparksPurple60: COLOR_SPARKS_PURPLE_60,
    sparksRed60: COLOR_SPARKS_RED_60,
    sparksTeal20: COLOR_SPARKS_TEAL_20,
    sparksYellow20: COLOR_SPARKS_YELLOW_20,
    sparksYellow30: COLOR_SPARKS_YELLOW_30,
    teal05: COLOR_TEAL_05,
    teal10: COLOR_TEAL_10,
    teal15: COLOR_TEAL_15,
    teal20: COLOR_TEAL_20,
    teal30: COLOR_TEAL_30,
    teal40: COLOR_TEAL_40,
    teal50: COLOR_TEAL_50,
    teal60: COLOR_TEAL_60,
    teal70: COLOR_TEAL_70,
    teal80: COLOR_TEAL_80,
    teal90: COLOR_TEAL_90,
    teal95: COLOR_TEAL_95,
    thirdPartyFacebookPrimary: COLOR_THIRD_PARTY_FACEBOOK_PRIMARY,
    thirdPartyLineA11y: COLOR_THIRD_PARTY_LINE_A11Y,
    thirdPartyLinePrimary: COLOR_THIRD_PARTY_LINE_PRIMARY,
    thirdPartyNoonlightPrimary: COLOR_THIRD_PARTY_NOONLIGHT_PRIMARY,
    thirdPartyNoonlightSecondary: COLOR_THIRD_PARTY_NOONLIGHT_SECONDARY,
    thirdPartySpotifyPrimary: COLOR_THIRD_PARTY_SPOTIFY_PRIMARY,
    thirdPartySpotifyPrimaryInverse: COLOR_THIRD_PARTY_SPOTIFY_PRIMARY_INVERSE,
    transparent: COLOR_TRANSPARENT,
    vaultIndigo20: COLOR_VAULT_INDIGO_20,
    vaultIndigo95: COLOR_VAULT_INDIGO_95,
    vaultPrimary: COLOR_VAULT_PRIMARY,
    vaultPrimaryLight: COLOR_VAULT_PRIMARY_LIGHT,
    white: COLOR_WHITE,
    yellowOrange05: COLOR_YELLOW_ORANGE_05,
    yellowOrange10: COLOR_YELLOW_ORANGE_10,
    yellowOrange15: COLOR_YELLOW_ORANGE_15,
    yellowOrange20: COLOR_YELLOW_ORANGE_20,
    yellowOrange30: COLOR_YELLOW_ORANGE_30,
    yellowOrange40: COLOR_YELLOW_ORANGE_40,
    yellowOrange50: COLOR_YELLOW_ORANGE_50,
    yellowOrange60: COLOR_YELLOW_ORANGE_60,
    yellowOrange70: COLOR_YELLOW_ORANGE_70,
    yellowOrange80: COLOR_YELLOW_ORANGE_80,
    yellowOrange90: COLOR_YELLOW_ORANGE_90,
    yellowOrange95: COLOR_YELLOW_ORANGE_95,
  },
  fontSize: {
    base: FONT_SIZE_BASE,
    body1Link: TYPE_STYLE_BODY_1_LINK.fontSize,
    body1Regular: TYPE_STYLE_BODY_1_REGULAR.fontSize,
    body1SparksSemibold: TYPE_STYLE_BODY_1_SPARKS_SEMIBOLD.fontSize,
    body1Strong: TYPE_STYLE_BODY_1_STRONG.fontSize,
    body2Link: TYPE_STYLE_BODY_2_LINK.fontSize,
    body2Regular: TYPE_STYLE_BODY_2_REGULAR.fontSize,
    body2SparksSemibold: TYPE_STYLE_BODY_2_SPARKS_SEMIBOLD.fontSize,
    body2Strong: TYPE_STYLE_BODY_2_STRONG.fontSize,
    body3Link: TYPE_STYLE_BODY_3_LINK.fontSize,
    body3Regular: TYPE_STYLE_BODY_3_REGULAR.fontSize,
    body3Strong: TYPE_STYLE_BODY_3_STRONG.fontSize,
    button1: TYPE_STYLE_BUTTON_1.fontSize,
    button2: TYPE_STYLE_BUTTON_2.fontSize,
    caption1Link: TYPE_STYLE_CAPTION_1_LINK.fontSize,
    caption1Regular: TYPE_STYLE_CAPTION_1_REGULAR.fontSize,
    caption1Strong: TYPE_STYLE_CAPTION_1_STRONG.fontSize,
    display1Regular: TYPE_STYLE_DISPLAY_1_REGULAR.fontSize,
    display1Strong: TYPE_STYLE_DISPLAY_1_STRONG.fontSize,
    display2Regular: TYPE_STYLE_DISPLAY_2_REGULAR.fontSize,
    display2SparksRegular: TYPE_STYLE_DISPLAY_2_SPARKS_REGULAR.fontSize,
    display2SparksStrong: TYPE_STYLE_DISPLAY_2_SPARKS_STRONG.fontSize,
    display2Strong: TYPE_STYLE_DISPLAY_2_STRONG.fontSize,
    display3Regular: TYPE_STYLE_DISPLAY_3_REGULAR.fontSize,
    display3Strong: TYPE_STYLE_DISPLAY_3_STRONG.fontSize,
    heading1: TYPE_STYLE_HEADING_1.fontSize,
    subheading1: TYPE_STYLE_SUBHEADING_1.fontSize,
    subheading2: TYPE_STYLE_SUBHEADING_2.fontSize,
  },
  gradient: {
    brandGradient: GRADIENT_BRAND_GRADIENT,
    brandSubtle: GRADIENT_BRAND_SUBTLE,
    brandSubtleOnDark: GRADIENT_BRAND_SUBTLE_ON_DARK,
    exploreAttributionGradient: GRADIENT_EXPLORE_ATTRIBUTION_GRADIENT,
    festivalModeGradient: GRADIENT_FESTIVAL_MODE_GRADIENT,
    gamepadBoost: GRADIENT_GAMEPAD_BOOST,
    gamepadBoostOnDark: GRADIENT_GAMEPAD_BOOST_ON_DARK,
    gamepadBoostSubtle: GRADIENT_GAMEPAD_BOOST_SUBTLE,
    gamepadBoostSubtleOnDark: GRADIENT_GAMEPAD_BOOST_SUBTLE_ON_DARK,
    gamepadLike: GRADIENT_GAMEPAD_LIKE,
    gamepadLikeOnDark: GRADIENT_GAMEPAD_LIKE_ON_DARK,
    gamepadLikeOnLight: GRADIENT_GAMEPAD_LIKE_ON_LIGHT,
    gamepadLikeSubtle: GRADIENT_GAMEPAD_LIKE_SUBTLE,
    gamepadLikeSubtleOnDark: GRADIENT_GAMEPAD_LIKE_SUBTLE_ON_DARK,
    gamepadNope: GRADIENT_BRAND_GRADIENT,
    gamepadNopeOnDark: GRADIENT_GAMEPAD_NOPE_ON_DARK,
    gamepadRewind: GRADIENT_GAMEPAD_REWIND,
    gamepadRewindOnDark: GRADIENT_GAMEPAD_REWIND_ON_DARK,
    gamepadSparksBoost: GRADIENT_GAMEPAD_SPARKS_BOOST,
    gamepadSparksLike: GRADIENT_GAMEPAD_SPARKS_LIKE,
    gamepadSparksNope: GRADIENT_GAMEPAD_SPARKS_NOPE,
    gamepadSparksRewind: GRADIENT_GAMEPAD_SPARKS_REWIND,
    gamepadSparksSuperLike: GRADIENT_GAMEPAD_SPARKS_SUPER_LIKE,
    gamepadSuperBoost: GRADIENT_GAMEPAD_SUPER_BOOST,
    gamepadSuperBoostOnDark: GRADIENT_GAMEPAD_SUPER_BOOST_ON_DARK,
    gamepadSuperBoostSubtle: GRADIENT_GAMEPAD_SUPER_BOOST_SUBTLE,
    gamepadSuperBoostSubtleOnDark: GRADIENT_GAMEPAD_SUPER_BOOST_SUBTLE_ON_DARK,
    gamepadSuperLike: GRADIENT_GAMEPAD_SUPER_LIKE,
    gamepadSuperLikeOnDark: GRADIENT_GAMEPAD_SUPER_LIKE_ON_DARK,
    gamepadSuperLikeOnLight: GRADIENT_GAMEPAD_SUPER_LIKE_ON_LIGHT,
    gamepadSuperLikeSubtle: GRADIENT_GAMEPAD_SUPER_LIKE_SUBTLE,
    gamepadSuperLikeSubtleOnDark: GRADIENT_GAMEPAD_SUPER_LIKE_SUBTLE_ON_DARK,
    hotTakesGradient: GRADIENT_HOT_TAKES_GRADIENT,
    matchExpirationGradient: GRADIENT_MATCH_EXPIRATION_GRADIENT,
    matchExpirationGradientOnDark: GRADIENT_MATCH_EXPIRATION_GRADIENT_ON_DARK,
    passionsGradient: GRADIENT_PASSIONS_GRADIENT,
    revenueGold: GRADIENT_REVENUE_GOLD,
    revenueGoldOnDark: GRADIENT_REVENUE_GOLD_ON_DARK,
    revenueGoldShine: GRADIENT_REVENUE_GOLD_SHINE,
    revenueGoldShineAnimation: GRADIENT_REVENUE_GOLD_SHINE_ANIMATION,
    revenueGoldShineAnimationOnDark: GRADIENT_REVENUE_GOLD_SHINE_ANIMATION_ON_DARK,
    revenueGoldShineOnDark: GRADIENT_REVENUE_GOLD_SHINE_ON_DARK,
    revenueGoldSubtle: GRADIENT_REVENUE_GOLD_SUBTLE,
    revenueGoldSubtleOnDark: GRADIENT_REVENUE_GOLD_SUBTLE_ON_DARK,
    revenuePlatinum: GRADIENT_REVENUE_PLATINUM,
    revenuePlatinumOnDark: GRADIENT_REVENUE_PLATINUM_ON_DARK,
    revenuePlatinumShine: GRADIENT_REVENUE_PLATINUM_SHINE,
    revenuePlatinumShineAnimation: GRADIENT_REVENUE_PLATINUM_SHINE_ANIMATION,
    revenuePlatinumShineAnimationOnDark: GRADIENT_REVENUE_PLATINUM_SHINE_ANIMATION_ON_DARK,
    revenuePlatinumShineOnDark: GRADIENT_REVENUE_PLATINUM_SHINE_ON_DARK,
    revenuePlatinumSubtle: GRADIENT_REVENUE_PLATINUM_SUBTLE,
    revenuePlatinumSubtleOnDark: GRADIENT_REVENUE_PLATINUM_SUBTLE_ON_DARK,
    revenuePlus: GRADIENT_REVENUE_PLUS,
    revenuePlusOnDark: GRADIENT_REVENUE_PLUS_ON_DARK,
    revenuePlusSubtle: GRADIENT_REVENUE_PLUS_SUBTLE,
    revenuePlusSubtleOnDark: GRADIENT_REVENUE_PLUS_SUBTLE_ON_DARK,
    sparksBackgroundGradient: GRADIENT_SPARKS_BACKGROUND_GRADIENT,
    sparksBackgroundGradientDark: GRADIENT_SPARKS_BACKGROUND_GRADIENT_DARK,
    sparksMatchmakerAttribution: GRADIENT_SPARKS_MATCHMAKER_ATTRIBUTION,
    spotifyMusicModeGradient: GRADIENT_SPOTIFY_MUSIC_MODE_GRADIENT,
    vaultGradient: GRADIENT_VAULT_GRADIENT,
    vaultSubtleOnDark: GRADIENT_VAULT_SUBTLE_ON_DARK,
    vaultSubtleOnLight: GRADIENT_VAULT_SUBTLE_ON_LIGHT,
    vibesGradient: GRADIENT_VIBES_GRADIENT,
  },
  letterCasing: {
    none: LETTER_CASING_NONE,
    body1Link: TYPE_STYLE_BODY_1_LINK.letterCasing,
    body1Regular: TYPE_STYLE_BODY_1_REGULAR.letterCasing,
    body1SparksSemibold: TYPE_STYLE_BODY_1_SPARKS_SEMIBOLD.letterCasing,
    body1Strong: TYPE_STYLE_BODY_1_STRONG.letterCasing,
    body2Link: TYPE_STYLE_BODY_2_LINK.letterCasing,
    body2Regular: TYPE_STYLE_BODY_2_REGULAR.letterCasing,
    body2SparksSemibold: TYPE_STYLE_BODY_2_SPARKS_SEMIBOLD.letterCasing,
    body2Strong: TYPE_STYLE_BODY_2_STRONG.letterCasing,
    body3Link: TYPE_STYLE_BODY_3_LINK.letterCasing,
    body3Regular: TYPE_STYLE_BODY_3_REGULAR.letterCasing,
    body3Strong: TYPE_STYLE_BODY_3_STRONG.letterCasing,
    button1: TYPE_STYLE_BUTTON_1.letterCasing,
    button2: TYPE_STYLE_BUTTON_2.letterCasing,
    caption1Link: TYPE_STYLE_CAPTION_1_LINK.letterCasing,
    caption1Regular: TYPE_STYLE_CAPTION_1_REGULAR.letterCasing,
    caption1Strong: TYPE_STYLE_CAPTION_1_STRONG.letterCasing,
    display1Regular: TYPE_STYLE_DISPLAY_1_REGULAR.letterCasing,
    display1Strong: TYPE_STYLE_DISPLAY_1_STRONG.letterCasing,
    display2Regular: TYPE_STYLE_DISPLAY_2_REGULAR.letterCasing,
    display2SparksRegular: TYPE_STYLE_DISPLAY_2_SPARKS_REGULAR.letterCasing,
    display2SparksStrong: TYPE_STYLE_DISPLAY_2_SPARKS_STRONG.letterCasing,
    display2Strong: TYPE_STYLE_DISPLAY_2_STRONG.letterCasing,
    display3Regular: TYPE_STYLE_DISPLAY_3_REGULAR.letterCasing,
    display3Strong: TYPE_STYLE_DISPLAY_3_STRONG.letterCasing,
    heading1: TYPE_STYLE_HEADING_1.letterCasing,
    subheading1: TYPE_STYLE_SUBHEADING_1.letterCasing,
    subheading2: TYPE_STYLE_SUBHEADING_2.letterCasing,
  },
  sizing: {
    0: SIZING_0,
    5: SIZING_5,
    10: SIZING_10,
    15: SIZING_15,
    20: SIZING_20,
    30: SIZING_30,
    40: SIZING_40,
    50: SIZING_50,
    60: SIZING_60,
    70: SIZING_70,
    80: SIZING_80,
    90: SIZING_90,
    100: SIZING_100,
    110: SIZING_110,
    120: SIZING_120,
    125: SIZING_125,
    130: SIZING_130,
    140: SIZING_140,
    150: SIZING_150,
    160: SIZING_160,
    170: SIZING_170,
    180: SIZING_180,
    190: SIZING_190,
    200: SIZING_200,
    210: SIZING_210,
    220: SIZING_220,
    230: SIZING_230,
    240: SIZING_240,
    borderRadiusLarge: SIZING_40,
    borderRadiusMedium: SIZING_30,
    borderRadiusSmall: SIZING_20,
    borderRadiusXlarge: SIZING_50,
    borderRadiusXsmall: SIZING_10,
    borderRadiusXxlarge: SIZING_60,
    borderRadiusXxsmall: SIZING_5,
    borderRadiusXxxlarge: SIZING_70,
    borderWidthRegular: SIZING_5,
    borderWidthThin: SIZING_0,
    buttonBorderRadius: SIZING_130,
    buttonBorderWidth: SIZING_5,
    buttonLargeIcon: SIZING_40,
    buttonLargePaddingHorizontal: SIZING_60,
    buttonLargePaddingVertical: SIZING_30,
    buttonMediumIcon: SIZING_40,
    buttonMediumPaddingHorizontal: SIZING_50,
    buttonMediumPaddingVertical: SIZING_20,
    buttonSmallIcon: SIZING_30,
    buttonSmallPaddingHorizontal: SIZING_40,
    buttonSmallPaddingVertical: SIZING_20,
    dimensionLarge: SIZING_110,
    dimensionMedium: SIZING_100,
    dimensionSmall: SIZING_90,
    dimensionXlarge: SIZING_120,
    dimensionXsmall: SIZING_80,
    dimensionXxlarge: SIZING_130,
    dimensionXxsmall: SIZING_70,
    dimensionXxxsmall: SIZING_60,
    iconLarge: SIZING_60,
    iconMedium: SIZING_50,
    iconSmall: SIZING_40,
    iconXlarge: SIZING_70,
    iconXsmall: SIZING_30,
    paddingLarge: SIZING_40,
    paddingMedium: SIZING_30,
    paddingSmall: SIZING_20,
    paddingXlarge: SIZING_50,
    paddingXsmall: SIZING_10,
    paddingXxlarge: SIZING_60,
    paddingXxsmall: SIZING_5,
  },
  fontFamily: {
    body1Link: TYPE_STYLE_BODY_1_LINK.fontFamily,
    body1Regular: TYPE_STYLE_BODY_1_REGULAR.fontFamily,
    body1SparksSemibold: TYPE_STYLE_BODY_1_SPARKS_SEMIBOLD.fontFamily,
    body1Strong: TYPE_STYLE_BODY_1_STRONG.fontFamily,
    body2Link: TYPE_STYLE_BODY_2_LINK.fontFamily,
    body2Regular: TYPE_STYLE_BODY_2_REGULAR.fontFamily,
    body2SparksSemibold: TYPE_STYLE_BODY_2_SPARKS_SEMIBOLD.fontFamily,
    body2Strong: TYPE_STYLE_BODY_2_STRONG.fontFamily,
    body3Link: TYPE_STYLE_BODY_3_LINK.fontFamily,
    body3Regular: TYPE_STYLE_BODY_3_REGULAR.fontFamily,
    body3Strong: TYPE_STYLE_BODY_3_STRONG.fontFamily,
    button1: TYPE_STYLE_BUTTON_1.fontFamily,
    button2: TYPE_STYLE_BUTTON_2.fontFamily,
    caption1Link: TYPE_STYLE_CAPTION_1_LINK.fontFamily,
    caption1Regular: TYPE_STYLE_CAPTION_1_REGULAR.fontFamily,
    caption1Strong: TYPE_STYLE_CAPTION_1_STRONG.fontFamily,
    display1Regular: TYPE_STYLE_DISPLAY_1_REGULAR.fontFamily,
    display1Strong: TYPE_STYLE_DISPLAY_1_STRONG.fontFamily,
    display2Regular: TYPE_STYLE_DISPLAY_2_REGULAR.fontFamily,
    display2SparksRegular: TYPE_STYLE_DISPLAY_2_SPARKS_REGULAR.fontFamily,
    display2SparksStrong: TYPE_STYLE_DISPLAY_2_SPARKS_STRONG.fontFamily,
    display2Strong: TYPE_STYLE_DISPLAY_2_STRONG.fontFamily,
    display3Regular: TYPE_STYLE_DISPLAY_3_REGULAR.fontFamily,
    display3Strong: TYPE_STYLE_DISPLAY_3_STRONG.fontFamily,
    heading1: TYPE_STYLE_HEADING_1.fontFamily,
    subheading1: TYPE_STYLE_SUBHEADING_1.fontFamily,
    subheading2: TYPE_STYLE_SUBHEADING_2.fontFamily,
  },
  fontWeight: {
    body1Link: TYPE_STYLE_BODY_1_LINK.fontWeight,
    body1Regular: TYPE_STYLE_BODY_1_REGULAR.fontWeight,
    body1SparksSemibold: TYPE_STYLE_BODY_1_SPARKS_SEMIBOLD.fontWeight,
    body1Strong: TYPE_STYLE_BODY_1_STRONG.fontWeight,
    body2Link: TYPE_STYLE_BODY_2_LINK.fontWeight,
    body2Regular: TYPE_STYLE_BODY_2_REGULAR.fontWeight,
    body2SparksSemibold: TYPE_STYLE_BODY_2_SPARKS_SEMIBOLD.fontWeight,
    body2Strong: TYPE_STYLE_BODY_2_STRONG.fontWeight,
    body3Link: TYPE_STYLE_BODY_3_LINK.fontWeight,
    body3Regular: TYPE_STYLE_BODY_3_REGULAR.fontWeight,
    body3Strong: TYPE_STYLE_BODY_3_STRONG.fontWeight,
    button1: TYPE_STYLE_BUTTON_1.fontWeight,
    button2: TYPE_STYLE_BUTTON_2.fontWeight,
    caption1Link: TYPE_STYLE_CAPTION_1_LINK.fontWeight,
    caption1Regular: TYPE_STYLE_CAPTION_1_REGULAR.fontWeight,
    caption1Strong: TYPE_STYLE_CAPTION_1_STRONG.fontWeight,
    display1Regular: TYPE_STYLE_DISPLAY_1_REGULAR.fontWeight,
    display1Strong: TYPE_STYLE_DISPLAY_1_STRONG.fontWeight,
    display2Regular: TYPE_STYLE_DISPLAY_2_REGULAR.fontWeight,
    display2SparksRegular: TYPE_STYLE_DISPLAY_2_SPARKS_REGULAR.fontWeight,
    display2SparksStrong: TYPE_STYLE_DISPLAY_2_SPARKS_STRONG.fontWeight,
    display2Strong: TYPE_STYLE_DISPLAY_2_STRONG.fontWeight,
    display3Regular: TYPE_STYLE_DISPLAY_3_REGULAR.fontWeight,
    display3Strong: TYPE_STYLE_DISPLAY_3_STRONG.fontWeight,
    heading1: TYPE_STYLE_HEADING_1.fontWeight,
    subheading1: TYPE_STYLE_SUBHEADING_1.fontWeight,
    subheading2: TYPE_STYLE_SUBHEADING_2.fontWeight,
  },
  lineHeight: {
    body1Link: TYPE_STYLE_BODY_1_LINK.lineHeight,
    body1Regular: TYPE_STYLE_BODY_1_REGULAR.lineHeight,
    body1SparksSemibold: TYPE_STYLE_BODY_1_SPARKS_SEMIBOLD.lineHeight,
    body1Strong: TYPE_STYLE_BODY_1_STRONG.lineHeight,
    body2Link: TYPE_STYLE_BODY_2_LINK.lineHeight,
    body2Regular: TYPE_STYLE_BODY_2_REGULAR.lineHeight,
    body2SparksSemibold: TYPE_STYLE_BODY_2_SPARKS_SEMIBOLD.lineHeight,
    body2Strong: TYPE_STYLE_BODY_2_STRONG.lineHeight,
    body3Link: TYPE_STYLE_BODY_3_LINK.lineHeight,
    body3Regular: TYPE_STYLE_BODY_3_REGULAR.lineHeight,
    body3Strong: TYPE_STYLE_BODY_3_STRONG.lineHeight,
    button1: TYPE_STYLE_BUTTON_1.lineHeight,
    button2: TYPE_STYLE_BUTTON_2.lineHeight,
    caption1Link: TYPE_STYLE_CAPTION_1_LINK.lineHeight,
    caption1Regular: TYPE_STYLE_CAPTION_1_REGULAR.lineHeight,
    caption1Strong: TYPE_STYLE_CAPTION_1_STRONG.lineHeight,
    display1Regular: TYPE_STYLE_DISPLAY_1_REGULAR.lineHeight,
    display1Strong: TYPE_STYLE_DISPLAY_1_STRONG.lineHeight,
    display2Regular: TYPE_STYLE_DISPLAY_2_REGULAR.lineHeight,
    display2SparksRegular: TYPE_STYLE_DISPLAY_2_SPARKS_REGULAR.lineHeight,
    display2SparksStrong: TYPE_STYLE_DISPLAY_2_SPARKS_STRONG.lineHeight,
    display2Strong: TYPE_STYLE_DISPLAY_2_STRONG.lineHeight,
    display3Regular: TYPE_STYLE_DISPLAY_3_REGULAR.lineHeight,
    display3Strong: TYPE_STYLE_DISPLAY_3_STRONG.lineHeight,
    heading1: TYPE_STYLE_HEADING_1.lineHeight,
    subheading1: TYPE_STYLE_SUBHEADING_1.lineHeight,
    subheading2: TYPE_STYLE_SUBHEADING_2.lineHeight,
  },
  letterSpacing: {
    body1Link: TYPE_STYLE_BODY_1_LINK.letterSpacing,
    body1Regular: TYPE_STYLE_BODY_1_REGULAR.letterSpacing,
    body1SparksSemibold: TYPE_STYLE_BODY_1_SPARKS_SEMIBOLD.letterSpacing,
    body1Strong: TYPE_STYLE_BODY_1_STRONG.letterSpacing,
    body2Link: TYPE_STYLE_BODY_2_LINK.letterSpacing,
    body2Regular: TYPE_STYLE_BODY_2_REGULAR.letterSpacing,
    body2SparksSemibold: TYPE_STYLE_BODY_2_SPARKS_SEMIBOLD.letterSpacing,
    body2Strong: TYPE_STYLE_BODY_2_STRONG.letterSpacing,
    body3Link: TYPE_STYLE_BODY_3_LINK.letterSpacing,
    body3Regular: TYPE_STYLE_BODY_3_REGULAR.letterSpacing,
    body3Strong: TYPE_STYLE_BODY_3_STRONG.letterSpacing,
    button1: TYPE_STYLE_BUTTON_1.letterSpacing,
    button2: TYPE_STYLE_BUTTON_2.letterSpacing,
    caption1Link: TYPE_STYLE_CAPTION_1_LINK.letterSpacing,
    caption1Regular: TYPE_STYLE_CAPTION_1_REGULAR.letterSpacing,
    caption1Strong: TYPE_STYLE_CAPTION_1_STRONG.letterSpacing,
    display1Regular: TYPE_STYLE_DISPLAY_1_REGULAR.letterSpacing,
    display1Strong: TYPE_STYLE_DISPLAY_1_STRONG.letterSpacing,
    display2Regular: TYPE_STYLE_DISPLAY_2_REGULAR.letterSpacing,
    display2SparksRegular: TYPE_STYLE_DISPLAY_2_SPARKS_REGULAR.letterSpacing,
    display2SparksStrong: TYPE_STYLE_DISPLAY_2_SPARKS_STRONG.letterSpacing,
    display2Strong: TYPE_STYLE_DISPLAY_2_STRONG.letterSpacing,
    display3Regular: TYPE_STYLE_DISPLAY_3_REGULAR.letterSpacing,
    display3Strong: TYPE_STYLE_DISPLAY_3_STRONG.letterSpacing,
    heading1: TYPE_STYLE_HEADING_1.letterSpacing,
    subheading1: TYPE_STYLE_SUBHEADING_1.letterSpacing,
    subheading2: TYPE_STYLE_SUBHEADING_2.letterSpacing,
  },
} as ObsidianBaseTheme;
